import { cmsAxios } from './axios-config';

const submitTerms = () => {
  return cmsAxios.post('/authentication/submit-terms', {});
};

export default submitTerms;
